















































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { FiltrosRecebimentoMonitor } from '@/types/interfaces/RecebimentoMonitor'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

/**
 * Janela padrão da tela: hoje mais os dois dias anteriores. A listagem sem recorte de data
 * varre toda a base de recebimentos e deixa a tela lenta, por isso o período já abre
 * preenchido e o botão de limpar volta para ele, não para "sem filtro" (FXSR-3152).
 */
const DIAS_PADRAO_PERIODO = 3
const FORMATO_DATA_HORA_INPUT = 'YYYY-MM-DDTHH:mm'

@Component
export default class ViewRecebimentoMonitor extends Vue {
  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadItemsRecebimentoMonitor: string = ''
  get loadingItemsRecebimentoMonitor() { return this.loadItemsRecebimentoMonitor }
  set loadingItemsRecebimentoMonitor(value: string) { this.loadItemsRecebimentoMonitor = value }

  loadItemsRecebimentoErros: string = ''
  get loadingItemsRecebimentoErros() { return this.loadItemsRecebimentoErros }
  set loadingItemsRecebimentoErros(value: string) { this.loadItemsRecebimentoErros = value }

  /** Aplicados na listagem; o rascunho de edição vive dentro do drawer. */
  statusSelecionado: string = ''
  nomeUsuario: string = ''
  dataInicio: string = ''
  dataFim: string = ''

  filtrosAvancadosVisiveis: boolean = false

  /** Enquanto false os watchers não buscam: evita recarregar a lista durante a montagem da tela. */
  podeBuscar: boolean = false

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itemsMonitoramentoCargasHeader() {
    return [
      { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
      { text: 'Código', value: 'codigo', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Usuário', value: 'usuario', align: 'center', sortable: false },
      { text: 'Inicializado', value: 'inicializado', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsMonitoramentoCargas() {
    return this.getFinanceiroStore.itemsMonitoramentoCargas
  }

  get totalRegistros() {
    return this.getFinanceiroStore.totalItemsMonitoramentoCargas
  }

  get tipos() {
    return this.getFinanceiroStore.tipoFilter
  }

  get statusList() {
    return this.getFinanceiroStore.statusFilter
  }

  get search() {
    return this.getFinanceiroStore.search
  }

  set search(value: any) {
    this.getFinanceiroStore.setSearch(value)
  }

  get qtdFiltrosAvancados(): number {
    return [this.statusSelecionado, this.nomeUsuario].filter(filtro => !!filtro).length
  }

  get temFiltroAvancado(): boolean {
    return this.qtdFiltrosAvancados > 0
  }

  get filtros(): FiltrosRecebimentoMonitor {
    return {
      statusEnum: this.statusSelecionado || undefined,
      nomeUsuario: this.nomeUsuario || undefined,
      dataInicio: this.dataInicio || undefined,
      dataFim: this.dataFim || undefined,
    }
  }

  async showItemsRecebimentoMonitor(item: any) {
    this.loadingItemsRecebimentoMonitor = item.id
    await this.getFinanceiroStore.getItemsRecebimentoMonitor(item.id)
    this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoMonitor', value: true })
    this.loadingItemsRecebimentoMonitor = ''
  }

  async showItemsErros(item: any) {
    this.loadingItemsRecebimentoErros = item.id
    await this.getFinanceiroStore.getItemsRecebimentoErros(item.id)
    this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoErros', value: true })
    this.loadingItemsRecebimentoErros = ''
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) {
      return 'Não informado'
    }

    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getFinanceiroStore.getItemsMonitoramentoCargas(this.filtros)
    this.loadingDataTable = false
  }

  /** Preenche o período com os últimos DIAS_PADRAO_PERIODO dias: do início do primeiro dia até agora. */
  aplicarPeriodoPadrao() {
    this.dataInicio = moment().subtract(DIAS_PADRAO_PERIODO - 1, 'days').startOf('day').format(FORMATO_DATA_HORA_INPUT)
    this.dataFim = moment().format(FORMATO_DATA_HORA_INPUT)
  }

  abrirFiltrosAvancados() {
    this.filtrosAvancadosVisiveis = true
  }

  fecharFiltrosAvancados() {
    this.filtrosAvancadosVisiveis = false
  }

  async aplicarFiltrosAvancados(filtros: { statusEnum: string, nomeUsuario: string }) {
    this.statusSelecionado = filtros.statusEnum
    this.nomeUsuario = filtros.nomeUsuario
    this.filtrosAvancadosVisiveis = false

    await this.buscarComFiltros()
  }

  async limparFiltrosAvancados() {
    this.statusSelecionado = ''
    this.nomeUsuario = ''

    await this.buscarComFiltros()
  }

  /** Limpar volta ao padrão de 3 dias, não a "sem filtro": sem período a tela fica lenta de novo. */
  async limparFiltros() {
    this.podeBuscar = false
    this.getFinanceiroStore.setSearch('')
    this.statusSelecionado = ''
    this.nomeUsuario = ''
    this.aplicarPeriodoPadrao()

    // Watcher do Vue e assincrono: sem esperar o flush, ele roda depois de a guarda
    // reabrir e cada campo alterado aqui viraria uma busca a mais.
    await this.$nextTick()
    this.podeBuscar = true

    await this.buscarComFiltros()
  }

  /** Qualquer mudança de filtro volta para a primeira página: a paginação anterior não vale mais. */
  async buscarComFiltros() {
    this.getPagina = 1

    await this.getAllItems()
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.podeBuscar = false
    this.getFinanceiroStore.setSearch('')
    this.statusSelecionado = ''
    this.nomeUsuario = ''
    this.aplicarPeriodoPadrao()
    this.getFinanceiroStore.setPagina(1)

    await this.getAllItems()

    this.getFinanceiroStore.getTipoFilter()
    this.getFinanceiroStore.getStatusFilter()

    await this.$nextTick()
    this.podeBuscar = true
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  @Watch('search')
  async onSearchChange() {
    if (!this.podeBuscar) {
      return
    }

    await this.buscarComFiltros()
  }

  /**
   * O campo datetime-local emite input a cada pedaco preenchido (dia, mes, ano, hora),
   * entao buscar no watcher direto viraria varias queries pesadas por edicao de periodo.
   */
  buscarPorPeriodoDebounce = _.debounce(async () => {
    await this.buscarComFiltros()
  }, 500)

  @Watch('dataInicio')
  onDataInicioChange() {
    if (!this.podeBuscar) {
      return
    }

    this.buscarPorPeriodoDebounce()
  }

  @Watch('dataFim')
  onDataFimChange() {
    if (!this.podeBuscar) {
      return
    }

    this.buscarPorPeriodoDebounce()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.totalItemsMonitoramentoCargas / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getItemsMonitoramentoCargas(this.filtros)
    this.loadingDataTable = false
  }
}
